import React from "react";
import "../../App.css";
import ReactPlayer from "react-player";

function Swinternship() {
  return (
    <div className="reel">
      <>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=HaE45Rh9Kqg"
          width="100%"
          height="100%"
          controls={true}
        />
      </>
    </div>
  );
}

export default Swinternship;
